import TagBase from '../PortfolioItemFields/FieldRenderer/TypeSpecificFieldRenderers/TagsField/AttachedTags/AttachedTag/TagBase';
import styled from '@emotion/styled';

const PortfolioItemTag = styled(TagBase)({
  marginRight: 4,
  marginBottom: 4,
  padding: '4px 8px',
  maxWidth: 100,
  fontWeight: 500,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  borderRadius: 4,
});

export default PortfolioItemTag;
